module.exports = __webpack_public_path__ + "img/icon-luyin.bb16b385.png";